import { render, staticRenderFns } from "./OnboardingCards.vue?vue&type=template&id=18f6f400&scoped=true&"
import script from "./OnboardingCards.vue?vue&type=script&lang=js&"
export * from "./OnboardingCards.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingCards.vue?vue&type=style&index=0&id=18f6f400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6f400",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VImg,VRow,VSelect,VTextField})
